module.exports = __webpack_public_path__ + "static/media/img1-2.2d245282.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/tomate/nutricheck_foliar/CA/img1-2.png
// module id = 2418
// module chunks = 3